import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import dynamic from "next/dynamic";
import LazyImage from "components/LazyImage";

import JSONLDCar from "../JSONLDCar";
import withObjectFitSupportDetection from "../../hocs/withObjectFitSupportDetection";
import preventDefaultAction from "../../utils/preventDefaultAction";
import CarTags from "../CarTags";

const FinancingDetailsOverlay = dynamic(() => import("../FinancingDetailsOverlay"));
const FinancingData = dynamic(() => import("../FinancingData"));

const TopOfferCard = (props) => {
  const {
    backgroundColor = "bg-white",
    offerUrl,
    brand,
    imageUrl,
    imageAlt,
    title,
    leasingOffer,
  } = props;

  return (
    <Link href={offerUrl}>
      <a className={`top-offer-card ${backgroundColor}`}>
        <JSONLDCar
          product={{
            brand,
            title,
            imageUrl,
            leasingOffer,
            offerUrl,
          }}
        />

        <div className="top-offer-card__content flex flex-col flex-grow border rounded items-center lg:hover:border-secondary-light lg:hover:shadow-hover lg::active:border-secondary-dark lg:active:shadow-active rounded-t-sm">
          <div className="top-offer-card__image px-4">
            <LazyImage
              src={imageUrl}
              alt={imageAlt}
              height={200}
              width={300}
              layout="fixed"
            />
          </div>

          <div className="pl-4 pr-4 pt-1 pb-3 w-full flex flex-col flex-grow bg-white rounded-b">
            <div className="-ml-1 mb-1">
              <CarTags product={props} small />
            </div>
            <p className="font-bold text-black text-base mb-3 cursor-pointer">{title}</p>
            <div className="flex flex-col xxs:flex-row justify-between items-center w-full mt-auto py-2 mb-1 border-t border-b border-secondary">
              <div className="flex flex-col items-baseline">
                <p className="text-sm xxs:text-lg mr-1 xxs:mr-0 font-bold text-secondary">
                  {leasingOffer.grossRate.priceString}
                  {" "}
                  <span className="text-sm text-secondary font-normal ">
                    mtl.
                  </span>
                </p>
                <p className="text-xs -mt-1">
                  {leasingOffer.netRate.priceString}
                  {" "}
                  netto
                </p>
              </div>
              <p className="btn btn--primary text-xs xxs:text-sm px-1">
                zum Angebot
              </p>
            </div>
            {
              !props.isBusinessOnly && (
                <div
                  className="paragraph--extra-small pt-2 text-center xxs:text-left"
                  onClick={(e) => preventDefaultAction(e)}
                >
                  <FinancingDetailsOverlay
                    title={title}
                    financingData={<FinancingData {...props} />}
                  />
                </div>
              )
            }
          </div>
        </div>
      </a>
    </Link>
  );
};

TopOfferCard.defaultProps = {
  offerUrl: "",
  imageUrl: "",
  imageAlt: "",
  title: "",
  leasingOffer: null,
};

TopOfferCard.propTypes = {
  offerUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  title: PropTypes.string,
  leasingOffer: PropTypes.object,
};

export default withObjectFitSupportDetection(TopOfferCard);
